export default __webpack_public_path__ + "static/media/mt4.7671c227.png";